import React, { FC, ReactElement, useContext, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as Yup from 'yup';
import { useFormik } from 'formik';

import { useHistory } from 'react-router-dom';
import { FormControl } from '../../ui/FormControl';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import { ReactComponent as FillClose } from '../../../assets/images/fillClose.svg';
import classes from './thowFactor.module.scss';
import { ReactComponent as Point } from '../../../assets/images/point.svg';
import { useAuth, useSecurity } from '../../../hooks/entityHooks';
import { Context } from '../../../services/context';

type FormikValues = {
  code: string;
};
type Props = {
  open: boolean;
  handleClose(): void;
  email: string;
  password: string;
};

export const TwoFactorAuth = ({
  open,
  handleClose,
  email,
  password,
}: Props) => {
  const [focus, setFocus] = useState(false);
  const { auth } = useAuth();
  const { login } = useSecurity();
  const history = useHistory();
  const { setLogin, setUserData } = useContext(Context);
  const useStyles = makeStyles({
    root: {
      background: '#FF7221 !important',
      borderRadius: 0,
      color: 'white !important',
      width: 190,
      fontSize: 16,
      fontFamily: 'HelveticaNeueCyr',
      fontWeight: 550,
      textTransform: 'none',
      '&:hover, &:focus': {
        background: '#C8524D !important',
      },
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 5px',
      marginLeft: 10,
    },
    cancel: {
      borderRadius: 0,
      color: '#FF7221 !important',
      fontWeight: 550,
      width: 190,
      fontSize: 16,
      border: ['1px', 'solid', '#FF7221', '!important'].join(' '),
      borderColor: '#FF7221',
      fontFamily: 'HelveticaNeueCyr',
      height: 50,
      padding: '0 5px',
      margitRight: 10,
      textTransform: 'none',
    },
    send: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 16,
      lineHeight: 16,
      height: 17,
      color: '#FF7221',

      textTransform: 'none',
    },
  });
  const {
    handleSubmit,
    handleBlur,
    values,
    errors,
    touched,
    setFieldValue,
    resetForm,
  } = useFormik<FormikValues>({
    initialValues: {
      code: '',
    },
    onSubmit: async () => {
      const authData = {
        code: values.code,
        email,
      };
      try {
        const response = await auth(authData);
        const role = response.data.user.roleName;
        const id = response.data.user.id.toString();
        if (setLogin) {
          setLogin(true);
          if (setUserData) {
            setUserData({
              email: email.split('@')[0],
              role: role || '',
              id: id || '',
            });
          }
        }
        // handleUserLogin(values.email);
        history.push('/structure');
        resetForm();
      } catch (e) {}

      handleClose();
    },
    validationSchema: Yup.object().shape({
      code: Yup.string().required('Поле обязательное для заполнения'),
    }),
  });

  const style = useStyles();
  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <form onSubmit={handleSubmit}>
          <DialogTitle>
            <div className={classes.form__dialogTitle}>
              <div className={classes.form__dialogTitle__title}>
                Авторизация
              </div>
              <div
                className={classes.close}
                onMouseOver={(e) => setFocus(true)}
                onMouseOut={(e) => setFocus(false)}
                onClick={(e) => handleClose()}
              >
                {focus ? <FillClose /> : <Close />}
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <div>
              <div className={classes.title}>
                <p>Код подтверждения</p>
                <Point className={classes.title__point} />
              </div>

              <div>
                <FormControl
                  placeholder="Введите код из письма"
                  type="text"
                  name="code"
                  value={values.code}
                  onChange={(e) => setFieldValue('code', e.target.value)}
                  error={Boolean(errors?.code && touched?.code)}
                  errorMessage={errors?.code}
                  onBlur={handleBlur}
                />
              </div>
              <div
                className={classes.sendCode}
                onClick={async () => {
                  const user = {
                    email,
                    password,
                  };
                  await login(user);
                }}
              >
                Выслать код повторно
              </div>
            </div>
          </DialogContent>
          <div className={classes.form__row__button}>
            <Button
              className={style.cancel}
              onClick={handleClose}
              color="primary"
            >
              Отмена
            </Button>
            <Button className={style.root} type="submit" color="primary">
              Войти
            </Button>
          </div>
        </form>
      </Dialog>
    </>
  );
};
